import { render, staticRenderFns } from "./PeopleDetails.vue?vue&type=template&id=70ede524"
import script from "./PeopleDetails.vue?vue&type=script&lang=js"
export * from "./PeopleDetails.vue?vue&type=script&lang=js"
import style0 from "./PeopleDetails.vue?vue&type=style&index=0&id=70ede524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports